import { render, staticRenderFns } from "./gallerySlideVertical.vue?vue&type=template&id=1729aba6&scoped=true&"
import script from "./gallerySlideVertical.vue?vue&type=script&lang=js&"
export * from "./gallerySlideVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729aba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
